module.exports = __webpack_public_path__ + "static/media/logo-에스큐엔티@3x.365d59d5.png";